const { Serializer } = require("jsonapi-serializer");

module.exports = {
  inactivateCampaignSerializer: (meta = {}) =>
    new Serializer("store", {
      meta,
      pluralizeType: false,
      keyForAttribute: "snake_case",
      attributes: [
        "campaign_id",
        "user_email",
        "user_ip"
      ]
    })
};
